

export class VehicleModelStatusInput implements IVehicleModelStatusInput {
    /** The auto-generated id of the vehicle model master */
    vehicleModelId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IVehicleModelStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleModelId = _data["vehicleModelId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleModelStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleModelId"] = this.vehicleModelId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleModelStatusInput {
    /** The auto-generated id of the vehicle model master */
    vehicleModelId: number;
    /** The updated status */
    status: number;
}

